import React, {Component} from 'react';
import PropTypes from 'prop-types';

import { CheckBoxSingle } from 'components/checkboxes/check-box-single';
import TemplateEOCView from './template-eoc-view';
import isEmpty from 'lodash/isEmpty';

class TemplateEOCList extends Component {

  static propTypes = {
    DefaultTemplateList: PropTypes.array,
    projectId: PropTypes.string,
    selectCustomTemplate: PropTypes.func,
    selectDefaultTemplate: PropTypes.func,
    getDefaultTemplate: PropTypes.func,
    getCustomTemplateDetail: PropTypes.func,
    customTemplateList: PropTypes.object,
    onEditCustomTemplate: PropTypes.func,
    onDuplicateEOCTemplate: PropTypes.func,
    onCopyEOCTemplate: PropTypes.func,
    ProjectListCopy: PropTypes.array,
    onFetchProject: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      templateId: null,
      isOpen: false,
      isSystemTemplate: false,
      ctxMenuList: {},
      ctxMenuCopy: {}
    };
  }

  componentDidMount() {
    window.addEventListener('click', e => {
      if (
        document.getElementById('box') &&
        document.getElementById('box').contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById('context-menu-eoc') &&
          document.getElementById('context-menu-eoc').contains(e.target)
        ) {
          // clicked in box
        } else {
          this.setState({ ctxMenuList: {}, ctxMenuCopy: {} });
        }
      }
    });

    this.props.onFetchProject({projectId: this.props.projectId});
  }

  componentWillUnmount() {
    // const self = this;
    window.removeEventListener('click', e => {
      if (
        document.getElementById('box') &&
        document.getElementById('box').contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById('context-menu-eoc') &&
          document.getElementById('context-menu-eoc').contains(e.target)
        ) {
          // clicked in box
        } else {
          this.setState({ ctxMenuList: {}, ctxMenuCopy: {} });
        }
      }
    });
  }

  viewCustomTemplateDetail = (id) => {
    this.setState({
      isOpen: true,
      isSystemTemplate: false,
      templateId: id
    });
  }

  viewDefaultTemplate = (id) => {
    this.setState({
      isOpen: true,
      templateId: id,
      isSystemTemplate: true
    });
  }

  onClose = () => {
    this.setState({
      isOpen: false
    });
  }

  onCheckedCustomTemplate = (id) => {
    const {projectId} = this.props;
    this.props.selectCustomTemplate({
      projectId: projectId,
      templateId: id
    }, () => this.props.getDefaultTemplate());
  }

  onCheckedDefaultTemplate = (id) => {
    const {projectId} = this.props;
    this.props.selectDefaultTemplate({
      projectId: projectId,
      templateId: id
    }, () => this.props.getDefaultTemplate());
  }

  onDuplicateEOC = (id) => {
    const {projectId} = this.props;
    this.props.onDuplicateEOCTemplate({
      projectId: projectId,
      templateId: id
    }, () => this.setState({ctxMenuList: {}},
      () => this.props.getDefaultTemplate()));
  }

  onCopyEOC = (projectId, templateId) => {
    this.props.onCopyEOCTemplate({
      sourceProjectId: this.props.projectId,
      targetProjectId: projectId,
      templateId: templateId
    }, () => this.setState({ctxMenuList: {}, ctxMenuCopy: {}},
      () => this.props.getDefaultTemplate()));
  }

  compareData = (a, b) => {
    const typeA = a.name;
    const typeB = b.name;

    if (typeA > typeB) {return 1;}

    if (typeB > typeA) {return -1;}

    return 0;
  }

  render() {
    const items = this.props.DefaultTemplateList;
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12 col-xs-12'>
            <span className='bolder-header'>System</span>
          </div>
        </div>
        {items.filter(x => x.typeValue === 'System').map((item, index) => <div key={index} style={{marginLeft: 0, borderRadius: '5px 5px'}} id='box' className='box-selection row'>
          <div onClick={() => this.viewDefaultTemplate(item.id)} className='items col-md-10 col-lg-10 col-sm-10 col-xs-9'>
            <span className='title'>{item.name}</span>
            <div><span className='default-color-create-by'>Created by</span> <span className='default-color-creator'>{item.createdByUser === null && 'System'}</span></div>
          </div>
          <div className='items col-md-2 col-lg-2 col-sm-2 col-xs-3'>
            <div style={{marginTop: -5}} className='group-action-button-eoc-template'>
              <CheckBoxSingle
                ref={c => { this.checkBox = c; }}
                style={{display: 'inline-block', marginBottom: 0}}
                disableClick={item.selected}
                onChecked={this.onCheckedDefaultTemplate.bind(this, item.id)}
                checked={item.selected}
              />
              <div className='context-menu-template'>
                <span
                  className='glyphicon glyphicon-option-vertical cls-table-black-icon'
                  onClick={() => {
                    if (this.state.ctxMenuList[item.id]) {
                      this.setState({ctxMenuList: {}});
                    } else {
                      setTimeout(() => {
                        this.setState({
                          ctxMenuList: {[item.id]: true}
                        });
                      }, 100);
                    }
                    this.setState({ isDisplayCtxMenu: true});
                  }} />
              </div>
              {this.state.ctxMenuList[item.id] &&
              <ul id='context-menu-eoc' className='top-level-menu'>
                <span className='contextMenuEOC'>
                  <li onClick ={() => this.state.ctxMenuCopy[item.id] ? this.setState({ctxMenuCopy: {}}) : this.setState({ctxMenuCopy: {[item.id]: true, isDisplayCtxMenuCopy: true}})} className='contextMenuEOC--option'>
                    <span className='context-menu-copy-eoc'>Copy to another project...</span>
                    <span style={{float: 'right'}}><i className={isEmpty(this.state.ctxMenuCopy) ? 'fa fa-caret-down' : 'fa fa-caret-right'} aria-hidden='true' /></span>
                    {this.state.ctxMenuCopy[item.id] &&
                    <ul className='second-level-menu'>
                      {/* map data here */}
                      {isEmpty(this.props.ProjectListCopy) ? <span className='contextMenuCopyNoResults'> <li className='contextMenuCopyNoResults--option'>
                        <span>(No Results Found)</span></li></span> : <span className='contextMenuCopy'>
                        {this.props.ProjectListCopy.sort(this.compareData).map(list =>
                          <li key={list.id} onClick={() => this.onCopyEOC(list.id, item.id)} className='contextMenuCopy--option'>
                            <span>{list.name}</span>
                          </li>
                        )}
                      </span>}
                    </ul>
                    }
                  </li>
                  <li onClick={() => this.onDuplicateEOC(item.id)} className='contextMenuEOC--option'>
                    <span className='context-menu-duplication-eoc'>Duplicate</span>
                  </li>
                </span>
              </ul>
              }
            </div>
          </div>
        </div>)
        }

        <div className='row'>
          <div className='col-lg-12 col-md-12 col-xs-12'>
            <span className='bolder-header'>Custom</span>
          </div>
        </div>
        {items.filter(x => x.typeValue === 'Custom').map((item, index) => <div key={index} id='box' style={{marginLeft: 0, borderRadius: '5px 5px'}} className='box-selection row'>
          <div onClick={() => this.viewCustomTemplateDetail(item.id)} className='items col-md-10 col-lg-10 col-sm-10 col-xs-9'>
            <span className='title'>{item.name}</span>
            <div><span className='default-color-create-by'>Created by</span> <span className='default-color-creator'>{item.createdByUser && item.createdByUser.displayName}</span></div>
          </div>
          <div className='items col-md-2 col-lg-2 col-sm-2 col-xs-3'>
            <div style={{marginTop: -5}} className='group-action-button-eoc-template'>
              <CheckBoxSingle
                ref={c => { this.checkBox = c; }}
                style={{display: 'inline-block', marginBottom: 0}}
                onChecked={this.onCheckedCustomTemplate.bind(this, item.id)}
                checked={item.selected}
                disableClick={item.selected}
              />
              <div className='context-menu-template'>
                <span
                  className='glyphicon glyphicon-option-vertical cls-table-black-icon'
                  onClick={() => {
                    if (this.state.ctxMenuList[item.id]) {
                      this.setState({ctxMenuList: {}});
                    } else {
                      setTimeout(() => {
                        this.setState({
                          ctxMenuList: {[item.id]: true}
                        });
                      }, 100);
                    }
                    this.setState({ isDisplayCtxMenu: true});
                  }} />
              </div>
              {this.state.ctxMenuList[item.id] &&
              <ul id='context-menu-eoc' className='top-level-menu'>
                <span className='contextMenuEOC'>
                  <li onClick ={() => this.state.ctxMenuCopy[item.id] ? this.setState({ctxMenuCopy: {}}) : this.setState({ctxMenuCopy: {[item.id]: true, isDisplayCtxMenuCopy: true}}) } className='contextMenuEOC--option'>
                    <span className='context-menu-copy-eoc'>Copy to another project...</span>
                    <span style={{float: 'right'}}><i className={isEmpty(this.state.ctxMenuCopy) ? 'fa fa-caret-down' : 'fa fa-caret-right'} aria-hidden='true' /></span>
                    {this.state.ctxMenuCopy[item.id] &&
                      <ul className='second-level-menu'>
                        {/* map data here */}
                        {isEmpty(this.props.ProjectListCopy) ? <span className='contextMenuCopyNoResults'> <li className='contextMenuCopyNoResults--option'>
                          <span>(No Results Found)</span></li></span> : <span className='contextMenuCopy'>
                          {this.props.ProjectListCopy.sort(this.compareData).map(list =>
                            <li key={list.id} onClick={() => this.onCopyEOC(list.id, item.id)} className='contextMenuCopy--option'>
                              <span>{list.name}</span>
                            </li>
                          )}
                        </span>}
                      </ul>
                    }
                  </li>
                  <li onClick={() => this.onDuplicateEOC(item.id)} className='contextMenuEOC--option'>
                    <span className='context-menu-duplication-eoc'>Duplicate</span>
                  </li>
                </span>
              </ul>
              }
            </div>
          </div>
        </div>)
        }
        {this.state.isOpen &&
        <TemplateEOCView
          isSystemTemplate={this.state.isSystemTemplate}
          onEditCustomTemplate={this.props.onEditCustomTemplate}
          customTemplateList={this.props.customTemplateList}
          onClose={this.onClose}
          isOpen={this.state.isOpen}
          templateId={this.state.templateId}
          projectId={this.props.projectId}
          getCustomTemplateDetail={this.props.getCustomTemplateDetail}
          getDefaultTemplate={this.props.getDefaultTemplate}

        />
        }
      </React.Fragment>
    );
  }
}

export default TemplateEOCList;



// WEBPACK FOOTER //
// ./src/Projects/Components/Template/template-eoc-list.js